import { useEffect, useMemo, useState } from 'react'
import './Cadence.scss'
import './StructureForm.scss'
import { useCadenceContext } from './useCadence'
import { CanEdit } from '@components/accessLevel'
import { Badge, Button, Popover, Select, Spin, Switch, Tooltip } from 'antd'
import HealthemSpinner, { Spinner } from '@components/healthemSpinner/healthemSpinner'
import { useGlobalInformationStore } from '@stores/global_informationStore'
import { useHelperApiFunctions, usePatientData } from '@utils/customHooks'
import { formatDisplayDate, milleniumClientCheck } from '@utils/helpers'
import DataNotFound from '@components/noDataFound'
import { NO_DATA_FOUND } from '../../constants/constants'
import { debounce, get, isEqual, keyBy } from 'lodash'
import patientProfileService from '@services/patientProfile.service'
import { SingleDropdown, StructureInput } from './StructureForm'
import moment from 'moment-timezone'
import { useMembersContext } from '@pages/members/useMembers'
import Icon from '@assets/icon_config'
import { MONTH } from '@components/drawerCalendar/constant'
import sess from '@services/session.service'

export function Cadence (props: any) {
    return (
        <div className="cadence">
            <ListCadence />
        </div>
    )
}

export function ListCadence () {
    const {
        setshowHistory,
        closeForm,
        patientName,
        cadences,
        setshowCadence
    } = useCadenceContext()

    useEffect(
        () => {
            setshowCadence(true)
            return () => {
                setshowCadence(false)
                setshowHistory(undefined)
                closeForm()
            }
        },
        []
    )
    return (
        <div className="cadence__list">
            {
                cadences.map(
                    (cadence: any) => <CadenceCard key={cadence.id} cadence={cadence} patientName={patientName} />
                )
            }
        </div>
    )
}

export function CadenceCard ({ cadence, patientName }: any) {
    const {
        showForm,
        toggelHistory,
        showHistory,
        frequencyValues,
        historyLoader,
        historyData
    } = useCadenceContext()

    const frequencies = keyBy(frequencyValues, 'value')

    return (
        <div className="cadence-card">
            <div className="cadence-card__header">
                {cadence.patient_name}
            </div>
            <div className="cadence-card__body">
                <div className="cadence-card__body__info">
                    <span>{moment(cadence.create_date).format('MM-DD-YYYY | hh:mm a')}</span> |
                    <span>{cadence.user_name}</span>
                </div>
                <div className="cadence-card__body__details">
                    <div className="detail-item">
                        <div className="detail-item__label">
                            Cadence Start Date
                        </div>
                        <div className="detail-item__value">
                            {formatDisplayDate(cadence.start_date, 'createDateFormat', 'defaultDateFormat')}
                        </div>
                    </div>
                    <div className="detail-item">
                        <div className="detail-item__label">
                            Cadence Frequency
                        </div>
                        <div className="detail-item__value">
                            {frequencies[cadence.frequency]?.title}
                        </div>
                    </div>
                    <div className="detail-item">
                        <div className="detail-item__label">
                            Cadence End Date
                        </div>
                        <div className="detail-item__value">
                            {cadence.end_date ? formatDisplayDate(cadence.end_date, 'createDateFormat', 'defaultDateFormat') : 'NA'}
                        </div>
                    </div>
                </div>
                <div className="cadence-card__body__actions">
                    <div className="cadence-card__body__actions__item">
                        {
                            cadence.is_completed !== 'Y' && cadence.user_id === sess.user.id &&
                            <CanEdit>
                            <Button block 
                                onClick={
                                    () => {
                                        let orgstartDate = moment(cadence.start_date)
                                        let isStarted = orgstartDate.isSameOrBefore(moment().startOf('date'))
                                        let startDate = isStarted ? moment() : orgstartDate
                                        showForm(
                                            {
                                                id: cadence.cadence_id,
                                                startDate: startDate,
                                                endDate: cadence.end_date ? moment(cadence.end_date) : null,
                                                frequency: cadence.frequency,
                                                status: isStarted ? 'started' : cadence.current_cycle_status
                                            }
                                        )
                                    }
                                }
                            >
                                Edit Cadence
                            </Button>
                            </CanEdit>
                        }
                    </div>
                    <div className="cadence-card__body__actions__item">
                        <Button disabled={historyLoader} className={(showHistory === cadence.cadence_id) ? 'muted' : ''} block onClick={
                            () => {
                                toggelHistory(cadence.cadence_id)
                            }
                        }>
                            View History
                        </Button>
                    </div>
                </div>
                {
                    showHistory === cadence.cadence_id &&
                    <div className="cadence-card__body__history">
                        <Spinner loading={historyLoader}  >
                            {
                                historyData.map(
                                    (d: any) => {
                                        return (
                                            <div className="history-item">
                                                <div className="history-item__time">{moment(d.eventDate).format('MM-DD-YYYY hh:mm A')}</div>
                                                <div className={`history-item__status ${d.statusClass}`}>
                                                    {d.statusMessage}
                                                </div>
                                            </div>
                                        )
                                    }
                                )
                            }
                        </Spinner>
                    </div>
                }
            </div>
        </div>
    )
}

export function AddCadenceForm () {
    const {
        cadenceLoader,
        closeForm,
        formData,
        setformData,
        createCadence,
        updateCadence,
        formLoader,
        frequencyValues,
    } = useCadenceContext()

    const addCadence = () => {
        createCadence(formData.startDate.format('YYYY-MM-DD'), formData?.endDate ? formData.endDate.format('YYYY-MM-DD') : null, formData.frequency)
    }
    
    const {
        patientId,
        patientName
    } = usePatientData()

    useEffect(() => {    
      selectedMembersHandler(patientId);
      setMembersOptions(
        [
            {
                patient_id: patientId,
                patient_name: patientName,
            }
        ]
      );
    },[]);

    const [originalFormData, setoriginalFormData] = useState({...formData})

    const globalPatientList = useGlobalInformationStore((state) => state.globalPatientList);
    const [membersOptions, setMembersOptions] = useState<any>(globalPatientList);
    const [selectedMembers, selectedMembersHandler] = useState<any>();
    const [fetchingPatientList, setFetchingPatientList] = useState<boolean>(false);
    const [searchMembersInputString, setSearchMembersInputString] = useState<any>(null);

    const getMembersList = (inputString: string) => {
        const searchPatient = inputString?.trim();
        setSearchMembersInputString(searchPatient);
        if (searchPatient.length > 2) {
          setFetchingPatientList(true);
          patientProfileService.fetchPatientsList({ patient_name: searchPatient }).subscribe({
            next: (v) => {
              let response = v?.data?.data;
              setMembersOptions(response);
              setFetchingPatientList(false);
            },
            error: (e) => {
              console.log(e);
              setFetchingPatientList(false);
            },
          });
        } else {
          setMembersOptions([]);
        }
    };
    
    const debouncedMemberSearch = debounce(getMembersList, 500);

    const formFields = [
        {
            key: 'entryType',
            label: 'Entry Type',
            value: 'Cadence',
            displayOrder: 1,
            struct_disp_type: 'DROPDOWN',
            rule: {
                disabled: true,
                defaultValue: 'Cadence',
            }
        },
        {
            key: 'startDate',
            label: 'Cadence Start Date ',
            value: formData.startDate,
            displayOrder: 2,
            struct_disp_type: 'DATE',
            rule: {
                disabled: formData.status,
                min: moment().startOf('date'),
                max: formData.endDate || undefined
            }
        },
        {
            key: 'frequency',
            label: 'Cadence Frequency',
            value: formData.frequency,
            displayOrder: 3,
            struct_disp_type: 'DROPDOWN',
            additional_info: {
                options: frequencyValues
            }
        },
        {
            key: 'endDate',
            label: 'Cadence End Date',
            value: formData.endDate,
            displayOrder: 4,
            struct_disp_type: 'DATE',
            rule: {
                min: moment(formData.startDate).startOf('date').add(1, 'days')
            }
        }
    ]

    const isValidForm = useMemo(
        () => {
            return formData.frequency && formData.startDate && !isEqual(formData, originalFormData)
        },
        [formData]
    )

    return (
        <div className="addNewNoteContainer">
          <div className="global_backdrop" />
          <div className={`outreachContainer`}>
            <h1 className="outreach-title">{"Record Entry"}</h1>
            <Spinner loading={cadenceLoader} size={70}>
            <div className={`memberlist-row-notes `}>
              <span className="icon-users" />
              <Select
                maxTagCount={2}
                showArrow={false}
                allowClear={false}
                // onFocus={}
                value={selectedMembers}
                disabled
                notFoundContent={fetchingPatientList ? <Spinner /> : membersOptions.length > 0 ? null : searchMembersInputString?.length > 3 ? <DataNotFound message={NO_DATA_FOUND} /> : null}
                placeholder="Search and Add Members"
                className="memberlist-select"
                filterOption={false}
                style={{ width: "100%" }}
                // onSearch={debouncedMemberSearch}
              >
                {membersOptions &&
                  membersOptions?.map((item: any, index: any) => (
                    <Select.Option key={item.patient_id} value={item.patient_id} item={item}>
                      <div className="outreach__options">
                        <div className="outreach__options__avatar-container">
                          <div className="outreach__options__avatar-container__name">{item?.patient_name}</div>
                        </div>
                        {item?.patient_dob ? (
                          <div className="outreach__options__dob">
                            {formatDisplayDate(item?.patient_dob, "createDateFormat", "defaultDateFormat")}
                          </div>
                        ) : null}
                      </div>
                    </Select.Option>
                  ))}
              </Select>
            </div>
            <div className="new-outreach-from">
                {
                    formFields.map(
                        (field) => {
                            let value = get(formData, field.key)
                            return (
                                <StructureInput input={field} value={value} handleChange={
                                    (value: any) => {
                                        setformData(
                                            {
                                                ...formData,
                                                [field.key]: value
                                            }
                                        )
                                    }
                                } />
                            )
                        }
                    )
                }
            </div>
            <div className="newNoteFooter">
              <Button type="text" size="large" className="cancel-button" onClick={closeForm}>
                Cancel
              </Button>
              <Spinner loading={formLoader}>
                <Button type="primary" size="large" disabled={!isValidForm} className="f16 w500 addNoteBtn" onClick={addCadence}>
                  {formData.id ?  "Update Entry" : "Add Entry"}
                </Button>
              </Spinner>
            </div>
            </Spinner>
          </div>
        </div>
    )
}

export function AddCadenceAction (props: any) {
    const {
        isFormOpen,
        showForm,
        cadences,
    } = useCadenceContext()

    const isActiveCadence = useMemo(
        () => {
            return cadences.find((i: any) => i.is_completed === 'N')
        },
        [cadences]
    )

    // console.log(isActiveCadence)

    return  (
        <>
      <CanEdit>
        <Button disabled={isActiveCadence} type="primary" shape="circle" icon={<span style={{ fontSize: "32px", top: "8%" }} className="icon-plus" />} size="large" className="addNewNote" onClick={
            () => {
                showForm()
            }
        } />
      </CanEdit>

      {isFormOpen && <AddCadenceForm />}
      </>
    )
}

export function CadenceStatus ({ cadence_status, className }: any) {  
    const {
        getStatusDetails
    } = useCadenceContext()

    let cadenceDetails = getStatusDetails(cadence_status)

    return milleniumClientCheck() ?
      <div className="cadence-status-wrapper">
        <Button
          shape="round"
          className={`cadence-status cadence-status--${cadence_status} ${className}`}
          size="middle"
        >
          {cadenceDetails?.name}
        </Button>
      </div>
      : <></>
}

export function CadenceListItem ({ cad, view, fetchMemberAndNavigateToProfile }: any) {
    const { handleSidebar } = useMembersContext()
    const { rightDrawerCloseHandler } = useCadenceContext()

    return (
        <div className={`allday-cadence allday-cadence--${cad.current_cycle_status} ${cad.is_completed === 'Y' && 'allday-cadence--completed'} allday-cadence--${view}`}>
        <div className="allday-cadence__patient__name" onClick={
            () => {
                fetchMemberAndNavigateToProfile({ patientId: cad.patient_id, successCallback: () => {handleSidebar(false); 
                    rightDrawerCloseHandler()} });
            }
        }>
            <Tooltip title={cad.patient_name}>
                <span >
                    {cad.patient_name}
                </span>
            </Tooltip>
        </div>
        <div className="allday-cadence__patient__complete">
            {
                cad.is_completed === 'Y' && <Icon name='tick-filled' />
            }
        </div>
        <div className="allday-cadence__patient__status">
            <CadenceStatus cadence_status={cad.current_cycle_status} className='cadence-status--label cadence-status--small' />
        </div>
        </div>
    )
}

export function NextOccurenceData ({ cadences }: any) {  
    const { patientFetchLoader, fetchMemberAndNavigateToProfile } = useHelperApiFunctions()

    return (
        <Spin spinning={patientFetchLoader} indicator={<HealthemSpinner />}>
        <div className="cadence-calendar-list">
            <div className="cadence-calendar-list__items">
                {
                    cadences.map(
                        (cad: any, i: number) => {
                            return (
                                <CadenceListItem cad={cad} key={i} fetchMemberAndNavigateToProfile={fetchMemberAndNavigateToProfile} />
                            )
                        }
                    )
                }
            </div>
        </div>
        </Spin>
    )
}

export function CalendarButton ({ view, date }: any) {
    let dateFormatted = moment(date).format('YYYY-MM-DD')
    const {calendarCadences} = useCadenceContext()
    
    let currentViewCadences = get(calendarCadences, view, [])

    let currentDateCadences = currentViewCadences.filter(
        (l: any) => l.current_cycle_next_occurence_date === dateFormatted
    )

    return currentDateCadences?.length > 0 ? (
        <>
            <Popover
                content={
                    <NextOccurenceData cadences={currentDateCadences} />
                }
                trigger={'hover'}

                className='cadence-calendar-button'
                overlayClassName='cadence-calendar-popup'
            >
                <Badge count={currentDateCadences?.length || 0}>
                    <Icon name={"cadence"} /> 
                </Badge>
            </Popover>
        </>
    ) : <></>
}

export function AllDayCadences ({ view, date}: any) {
    let dateFormatted = moment(date).format('YYYY-MM-DD')
    const {calendarCadences} = useCadenceContext()
    const { patientFetchLoader, fetchMemberAndNavigateToProfile } = useHelperApiFunctions()
    
    let currentViewCadences = get(calendarCadences, view, [])

    let currentDateCadences = currentViewCadences.filter(
        (l: any) => l.current_cycle_next_occurence_date === dateFormatted
    )

    if (!milleniumClientCheck()) {
        return <></>
    } 

    let showCadences = currentDateCadences

    let maxCadences = 3
    if (view === MONTH) {
        maxCadences = 4
    }

    if (currentDateCadences.length > maxCadences) {
        showCadences = currentDateCadences.slice(0, maxCadences - 1)
    }

    let remainingCadences = currentDateCadences.slice(maxCadences - 1, currentDateCadences.length)

    return (
        <div className={`ui-healthEm-day-view__header__allday allday-cadences allday-cadences--${view}`}>
            <Spin spinning={patientFetchLoader} indicator={<HealthemSpinner />}>
                {
                    showCadences.map(
                        (cad: any, i: number) => {
                            return (
                                <CadenceListItem cad={cad} view={view} key={i} fetchMemberAndNavigateToProfile={fetchMemberAndNavigateToProfile} />
                            )
                        }
                    )
                }
                {
                    remainingCadences.length > 0 && currentDateCadences.length > maxCadences &&
                    
                    <Popover
                        content={
                            <NextOccurenceData cadences={remainingCadences} />
                        }
                        trigger={'click'}
        
                        className='allday-cadence allday-cadence--more'
                        overlayClassName='cadence-calendar-popup'
                    >
                        <div className="">
                            +{remainingCadences.length} More
                        </div>
                    </Popover>
                }
            </Spin>
        </div>
    )
}

export function CalendarMonthViewSwitch () {
    const {
        calendarMonthView,
        setcalendarMonthView
    } = useCadenceContext()

    return (
        <div className="calendar-month-view__switch__wrapper">
            <div className="calendar-month-view__switch__label">
                Reminder
            </div>
            <div className="calendar-month-view__switch">
                <Switch
                    checked={calendarMonthView === 'cadences'}
                    onChange={
                        (checked) => setcalendarMonthView(checked ? 'cadences' : 'reminders')
                    }
                />
            </div>
            <div className="calendar-month-view__switch__label">
                Cadence
            </div>
        </div>
    )
}

export function CalendarMonthViewWrapper ({cadenceComponent, children}: any) {
    const {
        calendarMonthView
    } = useCadenceContext()
    
    return calendarMonthView === 'cadences' ? cadenceComponent : children
}